export default __webpack_public_path__ + "static/media/Quality.a13b8f21.svg";